import { createSlice } from "@reduxjs/toolkit";
import { AddDisplay, UpdateDisplay, GetDisplayList } from "services/other/display.service";
import { toast } from 'react-toastify';

export const displayAddSlice = createSlice({
  name: "displayAdd",
  initialState: {
    displayAdd: {},
    displayAddLoading: false,
    displayAddError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(AddDisplay.pending, (state) => {
      // toast.loading('We are adding the display 🤯')
      state.displayAddLoading = true
    });

    builder.addCase(AddDisplay.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('New display added successfully 👌');

      state.displayAdd = action.payload
      state.displayAddLoading = false
      state.displayAddError = null
    });

    builder.addCase(AddDisplay.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the display 😣")

      state.displayAddLoading = false
      state.displayAddError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});

export const displayUpdateSlice = createSlice({
  name: "displayUpdate",
  initialState: {
    displayUpdate: {},
    displayUpdateLoading: false,
    displayUpdateError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(UpdateDisplay.pending, (state) => {
      // toast.loading('We are updating the display 🤯')
      state.displayUpdateLoading = true
    });

    builder.addCase(UpdateDisplay.fulfilled, (state, action) => {
      toast.dismiss();
      // toast.success('Category update successfully 👌');

      state.displayUpdate = action.payload
      state.displayUpdateLoading = false
      state.displayUpdateError = null
    });

    builder.addCase(UpdateDisplay.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't update the display 😣")

      state.displayUpdateLoading = false
      state.displayUpdateError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});



export const displayListSlice = createSlice({
  name: "displayList",
  initialState: {
    displayList: [],
    displayListLoading: false,
    displayListError: null,
  },
  reducers: {},
  extraReducers: 
  (builder) => {
    builder.addCase(GetDisplayList.pending, (state) => {
      state.displayListLoading = true
    });

    builder.addCase(GetDisplayList.fulfilled, (state, action) => {
      toast.dismiss();

      state.displayList = action.payload
      state.displayListLoading = false
      state.displayListError = null
    });

    builder.addCase(GetDisplayList.rejected, (state, action) => {
      toast.dismiss();
      toast.error("Opps! We can't add the display 😣")

      state.displayListLoading = false
      state.displayListError = action.error?.message
      toast.error(action.error?.message)

    });
  },
});